import { PackagesPreview } from './Widget/PackagesPreview';
import { PackagePreviewWrapper } from './Widget/Scrollbar/PackagePreviewWrapper';
import { useWidgetBody } from './Widget/hooks/useWidgetBody';
import { WinePackagesLoadingSkeleton } from './skeleton/WinePackagesLoadingSkeleton';

interface RecommendedPackagesWidgetWebshopProps {
  data: string;
}

/**
 * @description This component is displayed in the webshop as a fully functioning widget.
 * @param0 data string; The data / widgetState of the widget.
 * @returns {JSX.Element} The GalleryWidgetWebshop component
 */

export const PackagesWidgetWebshop = ({ data }: RecommendedPackagesWidgetWebshopProps) => {
  if (!data || data === '{}') return <></>;

  const InnerPackageWidgetWebshop = () => {
    const recommendedPackagesData = JSON.parse(data);
    const { languageCode, winePackageList, isLoading } = useWidgetBody(data, recommendedPackagesData.packages);

    if (isLoading) return <WinePackagesLoadingSkeleton />;

    return <PackagesPreview languageCode={languageCode} item={recommendedPackagesData} winePackageList={winePackageList} />;
  };

  return (
    <PackagePreviewWrapper>
      <InnerPackageWidgetWebshop />
    </PackagePreviewWrapper>
  );
};
